import PropTypes from 'prop-types';
import './ModalNotificarPartido.scss';
import { message, Modal, Typography, Spin } from 'antd';
import { selectNotificarPartidoState } from 'selectors/notificarPartido.selector';
import { enviarNotificacionPartidos } from 'actions/notificarPartido.actions';
import { useDispatch, useSelector } from 'react-redux';
import InfoModal from 'components/InfoModal/Notificar/InfoModal';
import { useState } from 'react';

const { Text } = Typography;

const ModalNotificarPartido = (props) => {
  const { visible, tipo, seleccion, onClose, getMonitoreos } = props;
  const dispatch = useDispatch();
  const [visibleModalSuccess, setVisibleModalSuccess] = useState(false);
  const [visibleMessageError, setVisibleMessageError] = useState(false);
  const [messageErrorModal, setMessageErrorModal] = useState('');

  const { loading } = useSelector(selectNotificarPartidoState);

  const handleClose = () => {
    onClose?.();
  };

  // const monitoreosSinNotificar = (monitoreos) => {
  //   if (!monitoreos || monitoreos?.length === 0) return '';
  //   if (monitoreos?.length === 1) return monitoreos[0].toString();

  //   const primerMonitoreo = monitoreos.slice(0, -1).join(', ');
  //   const ultimoMonitoreo = monitoreos[monitoreos.length - 1];

  //   return `${primerMonitoreo} y ${ultimoMonitoreo}`;
  // };

  const getMonitoreosSeleccionados = (seleccionMonitoreos) => {
    const monitoreos = [];
    let listaIdsMonitoreos = [];
    Object.entries(seleccionMonitoreos.current).forEach(([key, value]) => {
      if (value) {
        monitoreos.push(key);
      }
    });
    if (monitoreos.length > 0) {
      listaIdsMonitoreos = monitoreos.map((monitoreo) => {
        const match = monitoreo.match(/\d+/);
        return match ? parseInt(match[0], 10) : null;
      });
    }
    return listaIdsMonitoreos;
  };

  const sendNotificacionPartido = async (seleccionMonitoreos) => {
    const listIds = getMonitoreosSeleccionados(seleccionMonitoreos);
    if (listIds.length > 0) {
      const dataload = {
        tipo,
        identificadores: listIds
      };
      const { success, response } = await dispatch(enviarNotificacionPartidos(dataload));

      if (success) {
        handleClose();
        setVisibleModalSuccess(true);

        const alert = response?.status === 'Alert';

        if (response.code === 204 && alert) {
          const mensajeCausa = response.message
            ? `${response.message}`
            : `No se encontró representante de finanzas para los monitoreos.`;
          setVisibleMessageError(true);
          setMessageErrorModal(mensajeCausa);
        }

        if (response?.seNotificaran?.length > 0) getMonitoreos();
      }
      if (!success) {
        handleClose();
        setVisibleModalSuccess(true);
        if (response.code === 204) {
          setVisibleMessageError(true);
          setMessageErrorModal(response.causa);
        }
      }
    } else {
      message.error('Debes seleccionar al menos un monitoreo.');
    }
  };

  return (
    <>
      <InfoModal
        open={visibleModalSuccess}
        onClose={() => {
          setVisibleModalSuccess(false);
          setVisibleMessageError(false);
        }}
        message={messageErrorModal}
        visibleMessage={visibleMessageError}
      />
      <Modal
        open={visible}
        width="45em"
        onCancel={handleClose}
        onOk={() => sendNotificacionPartido(seleccion)}
        okButtonProps={{ style: { width: '30%' }, loading }}
        cancelButtonProps={{ style: { width: '30%' }, loading }}>
        <div className="contenedorMensajeNotificar">
          {loading ? (
            <Spin />
          ) : (
            <Text className="modalNotificacionDescripcion">
              ¿Estás seguro que deseas enviar la notificación?
            </Text>
          )}
        </div>
      </Modal>
    </>
  );
};

ModalNotificarPartido.propTypes = {
  visible: PropTypes.bool.isRequired,
  tipo: PropTypes.number.isRequired,
  seleccion: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  getMonitoreos: PropTypes.func.isRequired
};

export default ModalNotificarPartido;
